import { Typewriter } from 'react-simple-typewriter';
import Particles from "react-tsparticles";
import ProfileImage from '../../../images/yeasin.png';
import './Hero.css';

const Hero = () => {

  const particlesInit = (main) => { };
  const particlesLoaded = (container) => { };

  return (
    <div id="hero">
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{

          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#fff",
            },
            links: {
              color: "#fff",
              distance: 150,
              enable: true,
              opacity: 0.1,
              width: 1,
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: .5,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-white hero-details" data-aos="fade-up"
            data-aos-duration="500">
            <p className="personal-profile__name">Yeasin Hossen</p>
            <p className="personal-profile__work">IT <span style={{ fontWeight: 'bold' }}>
              <Typewriter
                words={['Support Engineer', 'Support Specialist']}
                loop={5}
                cursor
                cursorStyle=''
                typeSpeed={50}
                deleteSpeed={20}
                delaySpeed={1000}
              />
            </span></p>
            <div className="personal-profile__contacts">
              <dl className="contact-list contact-list__opacity-titles">
                <dt>Address:</dt>
                <dd>Musa Sanaya,Riyadh,Saudi Arabia</dd>
                <dt>Phone:</dt>
                <dd><a href="tel:+966534840854">+966-534840854</a></dd>
                <dt>Email:</dt>
                <dd><a href="mailto:yeasinhossen173@gmail.com">yeasinhossen173@gmail.com</a></dd>
              </dl>
            </div>
            <div className="personal-profile__social">
              <a href="https://github.com/Yeasin307" target="_blank" rel="noreferrer"><i style={{ color: "white" }} className="fa fa-github"></i></a>
              <a href="https://www.linkedin.com/in/yeasinhossen/" target="_blank" rel="noreferrer"><i style={{ color: "blue" }} className="fab fa-linkedin-in"></i></a>
            </div>
          </div>
          <div className="col-md-4 profileBox" >
            <img className="profilePic" src={ProfileImage} alt="" data-aos="fade-up"
              data-aos-duration="500" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;